import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Header from "../component/layout/header";
import "../assets/css/login.css"; // SAME LOGIN CSS FOR MATCHING UI

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setshowConfirmPassword] = useState(false);

    
  const token = searchParams.get("token");
const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
      setSubmitted(true);   // 👈 mark form as submitted

    setError("");
    setMsg("");

    if (!password.trim() || !confirm.trim()) {
      setError("Please enter both fields");
      return;
    }

    // if (password.length < 6) {
    //   setError("Password must be at least 6 characters");
    //   return;
    // }
   // Strong password validation
if (
  !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[^\s]{8,}$/.test(password)
) {
  setError(
    "Password must be at least 8 characters and include uppercase, lowercase, number, and special character"
  );
  return;
}

    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }

    const res = await fetch("https://kalakakshaaha.com/kks/api/v1/reset-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    });

    const data = await res.json();

    if (!data.success) setError(data.message);
    else setMsg(data.message);

    if (data.success) {
      setTimeout(() => navigate("/login"), 1500);
    }
  };

  return (
    <>
      <Header />

      <div className="login-wrapper fadeIn">
        <div className="login-card">

          <h3 className="login-title">Reset Password</h3>
          <p style={{ textAlign: "center", color: "#444", marginBottom: "15px" }}>
            Enter your new password below
          </p>

          <form onSubmit={handleSubmit}>
          <div className="password-box" style={{display:"flex",justifyContent:"center",alignItems:"center"}}>

            {/* New Password */}
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New password *"
              className="login-input"
              value={password}
              onChange={(e) => {
               setPassword(e.target.value);
               if (submitted) setError("");   // 👈 clear error while typing
                }}              
            />
                      <i className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"} eye-icon`}
                          onClick={() => setShowPassword(!showPassword)}
                      ></i>
          </div>
           
                      
            {/* Confirm Password */}
                      <div className="password-box">

            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm password *"
              className="login-input"
              value={confirm}
onChange={(e) => {
    setConfirm(e.target.value);
    if (submitted) setError("");   // 👈 clear error while typing
                }}            />
             <i className={`fa-solid ${showConfirmPassword ? "fa-eye" : "fa-eye-slash"} eye-icon`}
                          onClick={() => setshowConfirmPassword(!showConfirmPassword)}
                      ></i>
                      </div>

            {/* Error */}
                  {submitted && error && (
                    <p className="validation-msg show">
                      {error}
                    </p>
                  )}


            {/* Success Message */}
            {msg && (
              <p style={{ textAlign: "center", color: "green", fontWeight: "600" }}>
                {msg}
              </p>
            )}

            <button className="login-btn">Save Password</button>
          </form>

        </div>
      </div>
    </>
  );
}
